var map = {
	"./10087 - Hundo - Branding - Logo White.png": 2946,
	"./NFT_banner_light_400x400.png": 5902,
	"./PNFTS.png": 84,
	"./dazed-logo-white.png": 2724,
	"./moca-logo-white.png": 6798,
	"./pinterest-wordmark-white.png": 6043,
	"./radiodayseu-logo-white.png": 1689,
	"./tcv3.png": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4057;